import type { ReactNode } from 'react'
import { AGENTIC_MODE_ENABLED } from '../constants/chat'
import { ChatSessionContext, type ChatSessionValue } from '../contexts/ChatSessionContext'
import { useAgentChat } from '../hooks/useAgentChat'
import { useSendMessage } from '../hooks/useSendMessage'

interface ChatSessionProviderProps {
  children: ReactNode
}

const useChatSessionHook = AGENTIC_MODE_ENABLED ? useAgentChat : useSendMessage

export const ChatSessionProvider = ({ children }: ChatSessionProviderProps) => {
  const sendMessageState: ChatSessionValue = useChatSessionHook()

  return <ChatSessionContext value={sendMessageState}>{children}</ChatSessionContext>
}
